import { render, staticRenderFns } from "./VerticalSelect.vue?vue&type=template&id=210f1b23&scoped=true&"
import script from "./VerticalSelect.vue?vue&type=script&lang=js&"
export * from "./VerticalSelect.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSelect.vue?vue&type=style&index=0&lang=less&"
import style1 from "./VerticalSelect.vue?vue&type=style&index=1&id=210f1b23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f1b23",
  null
  
)

export default component.exports